import { faCircleCheck, faCircleExclamation, faCircleXmark, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { DetailedHTMLProps, HTMLAttributes, useMemo } from 'react';
import Title from '../Title/Title';
import styles from './Notification.module.sass';

const Notification = ({
    children,
    variant, position, size
}: Props) => {
    const icon = useMemo(() => {
        switch (variant) {
            case 'error':
                return faCircleXmark;
            case 'warning':
                return faTriangleExclamation;
            case 'success':
                return faCircleCheck;
            case 'info':
            default:
                return faCircleExclamation;
        }
    }, [variant]);
    
    const translation = useMemo(() => {
        switch (variant) {
            case 'error':
                return 'Foutmelding';
            case 'warning':
                return 'Waarschuwing';
            case 'success':
                return 'Succesvol';
            case 'info':
            default:
                return 'Informatie';
        }
    }, [variant]);

    return <div className={`${styles['notification']} ${styles['notification__variant--'+(variant||'info')]} ${styles['notification__position--'+(position||'static')]}`}>
        <div className={styles['notification__icon']}>
            <FontAwesomeIcon icon={icon || faCircleExclamation} />        
        </div>
        <div className={styles['notification__content']}>
            { size === 'medium' && <Title size='small'>{translation}</Title> }
            { children }
        </div>
    </div>;
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    size?: 'small' | 'medium'
    variant?: 'error' | 'warning' | 'info' | 'success'
    position?: 'static' | 'floating'
}

export default Notification;